import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('Notification')

/** 👇 Use click notification menu */
const ClickNotificationMenu = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click notification',
  name: 'click_notification_menu',
});

/** 👇 Use click baca semua */
const ClickReadAll = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click baca semua',
  name: 'click_read_all',
});

/** 👇 Use click category semua */
const ClickSemua = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click category semua',
  name: 'click_semua',
});

/** 👇 Use click category konten */
const ClickKonten = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click category konten',
  name: 'click_konten',
});

/** 👇 Use click category event */
const ClickEvent = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click category event',
  name: 'click_event',
});

/** 👇 Use click category tanya saham */
const ClickTanyaSaham = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click category tanya saham',
  name: 'click_tanya_saham',
});

/** 👇 Use click category lainnya */
const ClickLainnya = () => analytics({
  label: GenerateLabel({}),
  action: 'notification - click category lainnya',
  name: 'click_lainnya',
});

/** 👇 Use click category lainnya,
 * category = konten/event/tanya saham/info
 */
const ClickNotification = ({ title = '', category = '' }) => analytics({
  label: GenerateLabel({ title, category }),
  action: 'notification - click notification',
  name: 'click_notification',
});

const Notification = {
  ClickNotificationMenu,
  ClickReadAll,
  ClickSemua,
  ClickKonten,
  ClickEvent,
  ClickTanyaSaham,
  ClickLainnya,
  ClickNotification,
};

export default Notification;
